import { IEsimReservation } from "../../interfaces/esim/EsimReservations.types";
import { IRefundStatusView, refundStatusView } from "../reservations/cancellationText";

// Cancelled (3) and Refunded (4): the only statuses that carry a refund row.
const REFUNDED_STATUSES = [3, 4];

// Where the bank says the eSIM's refund is, worded as on a bus booking's refund list. A Gjirafa Money
// refund already has the credit refund chip.
export const esimRefundView = (
  reservation: IEsimReservation,
  now: number = Date.now()
): IRefundStatusView | null => {
  if (!REFUNDED_STATUSES.includes(reservation.status) || !reservation.refundScheduledForUtc) return null;
  if (reservation.isRefundInCredits) return null;
  return refundStatusView(
    {
      id: reservation.id,
      amount: reservation.amountRefunded ?? 0,
      isRefundInCredits: !!reservation.isRefundInCredits,
      refundScheduledForUtc: reservation.refundScheduledForUtc,
      processorStatus: reservation.refundProcessorStatus,
      processorConfirmedAtUtc: reservation.refundProcessorConfirmedAtUtc
    },
    now
  );
};
